import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {booleanMetadata} from '../../../../../utils/builderMetadata'

export type DisplaySettingsParams = {
  showBreadcrumbs: SettingsParamType.Boolean
}

export const DEFAULT_DISPLAY_SETTINGS_PARAMS = {
  showBreadcrumbs: true,
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showBreadcrumbs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
      'Shows or hides the breadcrumbs at the top of the page',
    ),
  },
})
